import React from 'react';
import Link from 'next/link';
import styles from './Hero.module.scss';
import classNames from 'classnames/bind';

let cx = classNames.bind(styles);

export default function Hero({ data }) {
  if (!data) return null;

  const { header, subheader, background, backgroundDarkmode, buttonGroup, steps: stepsData } = data;

  // Ensure we have content to prevent hydration mismatches
  if (!header && !subheader) return null;

  // Build steps array from ACF data
  const steps = [];
  if (stepsData) {
    if (stepsData.stepsHeader) {
      steps.push({
        number: 1,
        title: stepsData.stepsHeader,
        description: stepsData.stepsDescription
      });
    }
    if (stepsData.stepsHeader2) {
      steps.push({
        number: 2,
        title: stepsData.stepsHeader2,
        description: stepsData.stepsDescription2
      });
    }
    if (stepsData.stepsHeader3) {
      steps.push({
        number: 3,
        title: stepsData.stepsHeader3,
        description: stepsData.stepsDescription3
      });
    }
  }

  return (
    <section className={cx('hero')}>
      <div className={cx('content')}>
        {/* Hero Header Section */}
        <div className={cx('hero-header')}>
          {header && <h1 dangerouslySetInnerHTML={{ __html: header }} />}
          {subheader && <p dangerouslySetInnerHTML={{ __html: subheader }} />}
          <div className={cx('buttons')}>
            {buttonGroup?.buttonLink1 && (
              <Link 
                href={buttonGroup.buttonLink1}
                className={cx('button-primary')}
              >
                {buttonGroup.buttonText1}
              </Link>
            )}
          </div>
        </div>

        {/* Steps Section */}
        <div className={cx('steps-section')}>
          <div className={cx('steps-container')}>
            {steps.map((step) => (
              <div key={step.number} className={cx('step-item')}>
                <div className={cx('step-header')}>
                  <div className={cx('step-number')}>
                    {step.number}
                  </div>
                  <h2 className={cx('step-title')}>{step.title}</h2>
                </div>
                {step.description && (
                  <div 
                    className={cx('step-description')} 
                    dangerouslySetInnerHTML={{ __html: step.description }} 
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
